module.exports = __webpack_public_path__ + "img/undraw_ideas_re_7twj.dcfb87d9.svg";